import {FC, PropsWithChildren} from 'react'
import {QueryClientProvider as ReactQueryQueryClientProvider} from 'react-query'

import {queryClient} from '../utils/react-query'

export const QueryClientProvider: FC<PropsWithChildren> = ({children}) => {
  return <ReactQueryQueryClientProvider client={queryClient}>{children}</ReactQueryQueryClientProvider>
}
